/*
 *   File : subscription-status.js
 *   Author : https://evoqins.com
 *   Description : Subscription modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';

// Assets
import EditProfileSuccess from "../../Assets/Images/Modal/edit-profile-success.webp";


//Custom components
import { Icon } from '../Icon';
import { PrimaryButton } from '../Buttons';

const EditProfileStatusModal = (props) => {

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {

        if (props.type === 2) {
            setTitle("Phone number updated successfully");
            setDescription("Your Phone number has been successfully updated");
        }
        else {
            setTitle("Email updated successfully");
            setDescription("Your Email has been successfully updated");
        }

    }, [props.type]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("edit-profile-success-modal");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        _handleCloseModal();
        props.handleSuccess();
    };

    return (
        <div className="modal fade"
            id="edit-profile-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="Edit Profile ModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5`}>
                <span id='edit-profile-success-modal' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 overflow-hidden border-0 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>
                    {/* Modal body */}
                    <div className='modal-body py-0 px-3 px-sm-4 text-center'>
                        <img src={EditProfileSuccess}
                            draggable={false}
                            width={200}
                            alt='edit-profile-success' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            {title}
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            {description}
                        </p>
                    </div>
                    {/* Modal footer */}
                    <div className='modal-footer border-0 padding-40px-lr padding-20px-tb d-block'>
                        <PrimaryButton name="Go Back"
                            className="w-100"
                            onPress={_handleSuccess} />
                    </div>
                </div>
            </div>
        </div>
    )
}

EditProfileStatusModal.defaultProps = {
    handleClose: () => { },
    className: null,
};

export default memo(EditProfileStatusModal);
